import React, { forwardRef } from 'react';
import './Input.css';

const Input = forwardRef(({ 
  label,
  error,
  success,
  disabled = false,
  required = false,
  type = 'text',
  placeholder,
  className = '',
  lightTheme = false,
  ...props 
}, ref) => {
  const inputClass = `input-field ${error ? 'input-error' : ''} ${success ? 'input-success' : ''} ${lightTheme ? 'light-theme' : ''} ${className}`.trim();
  const labelClass = `input-label ${lightTheme ? 'light-theme' : ''}`;

  return (
    <div className="input-container">
      {label && (
        <label className={labelClass}>
          {label}
          {required && <span className="input-required">*</span>}
        </label>
      )}
      <input
        ref={ref}
        type={type}
        className={inputClass}
        placeholder={placeholder}
        disabled={disabled}
        {...props}
      />
      {error && (
        <div className="input-error-message">
          {error}
        </div>
      )}
      {success && (
        <div className="input-success-message">
          {success}
        </div>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
